<template>
  <div id="footer" class="container-fluid">
    <div class="main">
      <div class="footer-nav-logo">
        <img src="../assets/images/tqzl-foot.png" />
      </div>
      <div class="content">
        <div class="service">
          <div class="title">产品&服务</div>
          <div class="list" @click="goToServicePage('pro_1')">TracePro芯片</div>
          <div class="list" @click="goToServicePage('pro_2')">智慧监控平台</div>
          <div class="list" @click="goToServicePage('pro_3')">
            TQZL物联网管理平台
          </div>
          <div class="list" @click="goToServicePage('pro_4')">
            视频分析与图像检测
          </div>
        </div>
        <div class="solution">
          <div class="title">解决方案</div>
          <div class="list" @click="goToSolutionPage('sol_1')">智慧安防</div>
          <div class="list" @click="goToSolutionPage('sol_2')">智慧社区</div>
        </div>
        <div class="contact">
          <div class="title">联系我们</div>
          <div class="lists">地址:杭州市余杭区未来科技城欧美金融城T5-621</div>
          <div class="lists">邮箱:Hztqzl_teach@163.com</div>
          <div class="lists">统一服务与咨询热线</div>
          <div class="phone">0571-86998376</div>
          <div class="phone">19957125796</div>
          <div class="QR">
            <img src="../assets/images/erweima.png" alt="" />
          </div>
        </div>
      </div>
      <p class="copy">
        Copyright &copy; 2023 杭州天启智联科技有限公司<img
          src="../assets/images/police.png"
          alt=""
        />
        <a href="https://beian.miit.gov.cn">备案浙ICP备2023016363号-1</a>
      </p>
    </div>
  </div>
</template>

<script>
import { getVisitCount, getClassifyByCode } from "../api/api";
export default {
  name: "Footer",
  data() {
    return {
      path:"",
      productCode:"productPage",
      solutionCode:"solutionPage",
    };
  },
  methods: {
    // 点击时跳转到 service 页面的 TracePro芯片部分
    goToServicePage(product) {
      const currentProduct = this.$route.query.product;
      if (currentProduct === product) {
        return;
      }
      this.path = 'product';
      this.handleCodeRequest(this.productCode,product);
    },
    goToSolutionPage(solution) {
      const currentSolution = this.$route.query.solution;
      if (currentSolution === solution) {
        return;
      }
      this.path = 'solution';
      this.handleCodeRequest(this.solutionCode,solution);
    },
    // 处理code请求并跳转
    async handleCodeRequest(code,childPath) {
      try {
        const result = await getClassifyByCode(code);
        this.$store.dispatch('updateCodeData', result.data);
        if(this.path == 'product'){
          this.$router.replace({ path: "/service", query: { product: childPath } });
        }else{
          this.$router.replace({ path: "/solution", query: { solution: childPath } });
        }
      } catch (error) {
        console.error("接口调用失败:", error);
        if(this.path == 'product'){
          this.$router.replace({ path: "/service", query: { product: childPath } });
        }else{
          this.$router.replace({ path: "/solution", query: { solution: childPath } });
        }
      }
    },
    getCount(){
      getVisitCount().then((res)=>{
        console.log(res)
      })
    },
  },
  created(){
    this.getCount();
  }
};
</script>

<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #2d2d2d;
  overflow: hidden;
  text-align: center;
}
.main {
  display: flex;
  flex-direction: column;
  padding: 1% 8% 0;
}
.service {
  flex: 1;
  margin-left: 10px;
  text-align: left;
}
.solution {
  flex: 1;
}
.copy {
  text-align: center;
  color: #d3d3d3;
  font-size: 14px;
}
.copy img {
  display: inline;
  margin: 0 5px;
}
/* 导航栏logo */
.footer-nav-logo {
  width: 130px;
  margin-bottom: 10px;
}
/* 导航栏logo图片 */
.footer-nav-logo img {
  width: 100%;
  height: auto;
}
.content {
  display: flex;
  justify-content: space-around;
  text-align: left;
  padding-bottom: 2%;
  border-bottom: 1px solid #706f70;
}
.content .title {
  color: #fff;
  font-weight: bold;
  font-size: 17px;
}
.content .list {
  color: #706f70;
  line-height: 35px;
  font-weight: bold;
  font-size: 15px;
  cursor: pointer; /* 添加此行以实现鼠标悬停时显示手形光标 */
}
.content .lists {
  color: #706f70;
  line-height: 35px;
  font-weight: bold;
  font-size: 15px;
}
.content .phone {
  color: #fff;
  line-height: 35px;
  font-weight: bold;
  font-size: 22px;
}
.content .QR {
  width: 100px;
}
.content .QR img {
  width: 100%;
  height: 100%;
}
/* 媒体查询（平板） */
@media screen and (min-width: 768px) and (max-width: 996px) {
  .content .title {
    color: #fff;
    font-weight: bold;
    font-size: 15px;
  }
  .content .list {
    color: #706f70;
    line-height: 35px;
    font-weight: bold;
    font-size: 14px;
    cursor: pointer; /* 确保平板设备上也显示手形光标 */
  }
  .content .lists {
    color: #706f70;
    line-height: 35px;
    font-weight: bold;
    font-size: 14px;
  }
}
/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  .service {
    display: none;
  }
  .solution {
    display: none;
  }
  .footer-nav-logo {
    width: 130px;
    margin: 0 auto 10px;
  }
  .content .title {
    display: none;
  }
  .content .list {
    color: #706f70;
    line-height: 25px;
    font-weight: bold;
    font-size: 15px;
    cursor: pointer; /* 确保手机设备上也显示手形光标 */
  }
  .content .lists {
    color: #706f70;
    line-height: 25px;
    font-weight: bold;
    font-size: 15px;
  }
  .content .phone {
    color: #fff;
    line-height: 25px;
    font-weight: bold;
    font-size: 16px;
  }
  .contact {
    text-align: center;
  }
  .content .QR {
    width: 80px;
    margin: 0 auto;
  }
  .content .QR img {
    width: 100%;
    height: 100%;
  }
  .copy {
    text-align: center;
    font-size: 12px;
    margin: 10px 0 10px;
  }
  .copy img {
    display: inline;
    margin: 0 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue